export default __webpack_public_path__ + "static/media/6-WashDay.1e653965.jpeg";